module.exports = __webpack_public_path__ + "src/assets/img/stamp.761f72ac.png";